export default __webpack_public_path__ + "static/media/Animals2_14.eebc9080.png";